import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import TopMatter from 'reservations/account/components/TopMatter';
import { useLocation } from 'reservations/account/providers/ConfigProvider';
import { formatPhone } from 'reservations/base/helpers/phone';
import { WHITE } from 'reservations/brand/constants';

const StyledDetailsContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  alignItems: 'left',
  justifyContent: 'left'
}));

export const TopMatterWithDetails = () => {
  const { phone_number: phoneNumber, street } = useLocation();

  return (
    <TopMatter>
      <StyledDetailsContainer item container spacing="16px">
        <Grid item>
          <Typography sx={{ color: WHITE }}>{street}</Typography>
        </Grid>
        {phoneNumber && (
          <Grid item>
            <Typography data-testid="phone" sx={{ color: WHITE }}>
              {formatPhone(phoneNumber)}
            </Typography>
          </Grid>
        )}
      </StyledDetailsContainer>
    </TopMatter>
  );
};
